
import Vue from 'vue'
import type { AdminTabIndex } from '@/utils/listParagonRouteQuery'

export default Vue.extend({
  name: 'Menu',
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    onChange(tab: AdminTabIndex) {
      this.$emit('input', tab)
      this.$emit('change', tab)
    },
  },
})
